import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { scrollToId } from "../lib/stageState";
import { useWaitlist } from "./WaitlistDialog";

const LINKS = [
  { id: "story", label: "Story" },
  { id: "services", label: "Services" },
  { id: "trust", label: "Trust" },
];

export const Wordmark = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <span className="block w-2 h-2 rotate-45 border border-[color:var(--axt-accent)]" aria-hidden="true" />
    <span className="font-display text-lg tracking-[0.2em] text-[color:var(--axt-text)]">AXTARA</span>
    <span className="hidden sm:block h-3 w-px bg-white/40" aria-hidden="true" />
    <span className="hidden sm:block font-mono-axt text-[9px] tracking-[0.18em] text-white/55">EST. 2026</span>
  </span>
);

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const { open } = useWaitlist();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="top-nav"
      className="fixed top-0 inset-x-0 z-50"
      style={{
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        backgroundColor: scrolled ? "rgba(0,0,0,0.7)" : "rgba(0,0,0,0.15)",
        borderBottom: `1px solid ${scrolled ? "rgba(255,255,255,0.2)" : "rgba(255,255,255,0.08)"}`,
        transition: "background-color 400ms ease, border-color 400ms ease",
      }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
        <a
          href="#story"
          data-testid="nav-wordmark"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white/60 rounded-sm"
        >
          <Wordmark />
        </a>

        <div className="hidden xl:flex items-center gap-3 font-mono-axt text-[10px] tracking-[0.12em] text-white/50" aria-hidden="true">
          <span>LAT: 38.9072° N</span>
          <span className="w-1 h-1 bg-white/40 rounded-full" />
          <span>LONG: 77.0369° W</span>
        </div>

        <nav className="hidden md:flex items-center gap-1" aria-label="Primary">
          {LINKS.map((l) => (
            <Button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              variant="ghost"
              onClick={() => scrollToId(l.id)}
              className="h-9 px-3 rounded-sm font-mono-axt text-[11px] tracking-[0.18em] uppercase text-white/60 hover:text-white hover:bg-white/[0.06] transition-[background-color,color] duration-200"
            >
              {l.label}
            </Button>
          ))}
        </nav>

        <Button data-testid="nav-book-walkthrough-button" onClick={() => open("nav")} className="axt-btn-primary h-10 px-4 sm:px-5">
          <span className="sm:hidden">Waitlist</span>
          <span className="hidden sm:inline">Join the waitlist</span>
        </Button>
      </div>
    </header>
  );
};

/* Fixed viewport corner frame — technical blueprint framing */
export const CornerFrame = () => (
  <>
    <div className="axt-corner top-0 left-0 border-t border-l" aria-hidden="true" />
    <div className="axt-corner top-0 right-0 border-t border-r" aria-hidden="true" />
    <div className="axt-corner bottom-0 left-0 border-b border-l" aria-hidden="true" />
    <div className="axt-corner bottom-0 right-0 border-b border-r" aria-hidden="true" />
  </>
);
